export const CONFIG ={
  // url: 'http://192.168.3.23/',    
  url: 'https://api.infofactperu.pe/',    
  url_socket: 'https://api.infofactperu.pe/notify',
  versionApi: 'api',
};
